"use client"

import { useEffect, useState } from "react"
import { useCmdkContext } from "../context"
import { CmdkPage } from "../types"

/**
 * Subscribe to the palette's open sub-page (`null` on the root page). Lets
 * item registrars outside the `<Cmdk/>` component scope themselves to a page.
 */
export function useCmdkPage(): CmdkPage | null {
  const ctx = useCmdkContext()
  const [page, setPage] = useState(ctx.pageRef.current)

  useEffect(
    () =>
      ctx.onPageUpdated(() => {
        setPage(ctx.pageRef.current)
      }),
    [ctx],
  )

  return page
}
